import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon, Url } from '#const';
import { getIconUrl } from '#utils';

const IconList = dynamic(() => import('./IconList'));

export const defaultOptions = {
	heading: '<h2>Icon List</h2>',
	listItems: [
		{
			icon: Url.DEFAULT_ICON,
			text: '<p>Placeholder text.</p>',
		},
		{
			icon: Url.DEFAULT_ICON,
			text: '<p>Placeholder text.</p>',
		},
		{
			icon: Url.DEFAULT_ICON,
			text: '<p>Placeholder text.</p>',
		},
	],
	secondaryHeroLoc: false,
} as const;

Builder.registerComponent(IconList, {
	name: 'IconList',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Heading',
			type: 'richText',
			required: true,
			defaultValue: defaultOptions.heading,
		},
		{
			name: 'listItems',
			friendlyName: 'List Items',
			type: 'list',
			copyOnAdd: true,
			subFields: [
				{
					name: 'icon',
					friendlyName: 'Icon',
					type: 'file',
					allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
					required: false,
					defaultValue: Url.DEFAULT_ICON,
				},
				{
					name: 'text',
					friendlyName: 'Text',
					type: 'richText',
					required: true,
					defaultValue: '<p>Placeholder text.</p>',
				},
			],
			defaultValue: [...defaultOptions.listItems],
		},
		{
			name: 'secondaryHeroLoc',
			friendlyName: 'Show In Secondary Hero Location',
			type: 'boolean',
			defaultValue: defaultOptions.secondaryHeroLoc,
		},
	],
	image: getIconUrl(Icon.IMAGE_TEXT_SECTION),
});
